// @flow
import { MEDIA_TEXT_HORIZONTAL } from 'Client/cms/toolkit/constants';
import { MediaTextHorizontalLine } from 'Components/lines/media-text-horizontal-line/MediaTextHorizontalLine.jsx';
import { mediaTextHorizontalResolver } from './mediaTextHorizontal.resolver';

export const mediaTextHorizontalDescriptor = {
  name: MEDIA_TEXT_HORIZONTAL,
  component: MediaTextHorizontalLine,
  resolve: mediaTextHorizontalResolver.resolve,
};
